module.exports = __webpack_public_path__ + "img/guanzhu.ec883f5f.png";